export const PropertyAccessLevel = {
    MINOR: 'minor',
    UNRESTRICTED: 'unrestricted',
    LIMITED: 'limited',
    GATED: 'gated'
};

export function getPropertyAccessLevel({ user, org, userProperty }) {
    if (!user || !org || !userProperty) {
        return PropertyAccessLevel.GATED;
    }

    if (userProperty?.minor === true) {
        return PropertyAccessLevel.MINOR;
    }

    if (user?.identity_verified === true) {
        return PropertyAccessLevel.UNRESTRICTED;
    }

    if (org?.user_verification_required === true) {
        return userProperty?.id_verification_override === true
            ? PropertyAccessLevel.LIMITED
            : PropertyAccessLevel.GATED;
    }

    return PropertyAccessLevel.LIMITED;
}